<div id="pnsvl" class="mt-3">
  <h4>Cancel Booking Refund Quote</h4>
  <div class="cxBox">
    <div class="row">
      <div class="col-sm-7"></div>
      <div class="col-sm-5">
        <div class="pnfin">
          <h4>Refund Amount Due</h4>
          <form [formGroup]="cancelScreenForm">
            <div class="row">
              <div class="col-sm-3"><b>Total</b></div>
              <div class="col-sm-8 pl-0 pr-2">
                <div class="flPrice txtRt">{{ inp_group_control('priceDetails', 'total').value }}</div>
              </div>
              <div class="col-sm-1 pull-right pl-0 pr-2">
                <span class="smcur">{{ inp_group_control('priceDetails', 'currency').value }}</span>
              </div>
            </div>
          </form>
        </div>
        <button role="button" type="button" class="mt-20 ba-btn ba-btn-thin pull-right fullWidth" data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
          <i class="fa fa-times-circle"></i> CANCEL BOOKING
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <div class="modal cancelPopup" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">CANCEL BOOKING ?</h5>
                <button type="button" class="btn-close close" data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">Confirm Cancel this Flight</div>
              <div class="modal-footer">
                <button type="button" class="grayBtn" data-bs-dismiss="modal" (click)="confirmCancelBooking()" aria-label="Close">Yes</button>
                <button type="button" class="grayBtn" data-bs-dismiss="modal" aria-label="Close">No</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
